<template>
  <tippy
    ref="tippy"
    tag="div"
    content-tag="div"
    :animate-fill="false"
    :interactive="true"
    :interactive-debounce="55"
    animation="shift-away-subtle"
    :duration="[200, 250]"
    placement="right-start"
    follow-cursor="initial"
    trigger="click"
    theme="dropdown"
    :on-hide="hideBackdrop">
    <template #content="{ hide }">
      <!-- <div class="card nope-card-stacked"> -->
      <!-- <button @click="hide()">close</button> -->
      <div
        class="b-menu dropdown-menu show"
        style="overflow: visible; min-width: 240px"
        ntyle="
            display: inline-block;
            width: 100%;
            position: relative;
            top: 0;
            box-shadow: none;
          ">
        <span class="dropdown-header">{{ app.name }}</span>

        <!--
          *+---------------------------------
          *| States block
          *| Inner dropdown with states
          *+--------------------------------- -->
        <div class="dropdown-item">
          <div class="d-flex nope-justify-content-center" style="width: 30px">
            <span
              v-if="app.state && currState"
              class="status-dot status-dot-animated"
              style="margin-left: 5px"
              :style="{ 'background-color': currState?.color || 'transparent' }"></span>
            <Icon name="tabler:background" v-else size="16" width="1" class="text-muted" />
          </div>

          <span>
            {{ app.state && currState ? currState.name : 'Assign a state' }}
          </span>

          <span class="text-muted ms-auto">
            <Icon name="tabler:caret-right-filled" size="12" />
          </span>
          <b-dropdown
            singleton-group="manager"
            placement="right-start"
            appendTo="body"
            style="overflow: visible; min-width: 240px">
            <template v-for="(state, i) in states" :key="'state-' + i">
              <div
                v-if="state.id > -1"
                class="dropdown-item"
                :class="{ active: app.state == state.id }"
                @click="setState(state)">
                <!-- <div
                v-if="app.state"
                class="selection"
                style="margin-right: 0.55rem; transform: translateY(-1px)">
                <!-- <input
                  type="checkbox"
                  class="form-check-input"
                  style="transform: scale(0.8)" /> - ->
                <Icon name="tabler:square-check" v-if="app.state == state.id" style="color: var(--tblr-primary)" />
                <Icon name="tabler:square" v-else style="color: #666" />
              </div> -->
                <div class="d-flex justify-center" style="width: 30px">
                  <span
                    class="status-dot me-2"
                    :style="{ 'background-color': state.color || '' }"
                    :class="{ 'status-dot-animated': app.state == state.id }"></span>
                </div>
                <div>
                  {{ state.name }}

                  <div v-if="app.state == state.id" class="text-muted" style="font-size: 0.75rem">
                    <span v-if="app && app.is && app.is.state && app.is.state['state_' + state.id]">
                      {{ dates.timeAgo(app.is.state['state_' + state.id] * 1000) }}
                    </span>

                    <code class="mx-2">
                      <Icon name="tabler:arrow-back" size="10" width="1" class="" />
                      Undo
                    </code>
                  </div>
                </div>

                <tippy class="text-muted ms-auto cursor-help" :content="state.description">
                  <span class="form-help">?</span>
                </tippy>

                <!-- <tippy
                class="text-muted ms-auto cursor-help ps-4"
                :content="state.description">
                <Icon name="tabler:help-small" width="2" style="background: rgb(0 0 0 / 20%); border-radius: 50%" />
              </tippy> -->
                <!-- <div
                class="content d-flex align-items-center w-100 px-1"
                :class="{ 'control-hover': app.state }">
                <div>
                  <span
                    class="status-dot me-2"
                    :style="{ 'background-color': state.color || '' }"
                    :class="{ 'status-dot-animated': app.state == state.id }"></span>

                  <span class="me-4" nope:class="{ 'hide-hover': app.state == state.id }">
                    {{ state.name }}
                  </span>
                  <small
                    class="d-block text-muted pe-4 me-4"
                    style="margin-left: -2px"
                    v-if="app.state == state.id">
                    <Icon name="tabler:toggle-left" size="12" width="1" style="margin-right: 2px; margin-top: -1px" />
                    Click again to reset
                  </small>
                </div>

                <tippy
                  v-if="state.description"
                  class="text-muted ms-auto ms-1 cursor-help"
                  :content="state.description">
                  <span class="form-help">?</span>
                </tippy>
              </div> -->
              </div>
            </template>
          </b-dropdown>
        </div>

        <!--
          *+---------------------------------
          *| Lists block
          *| Inner dropdown with lists
          *+--------------------------------- -->
        <div class="dropdown-item">
          <div class="d-flex nope-justify-content-center" style="width: 30px">
            <Icon name="tabler:mist" size="18" width="1" class="text-muted" />
          </div>

          <span>Add to a list</span>

          <span class="text-muted ms-auto">
            <Icon name="tabler:caret-right-filled" size="12" />
          </span>
          <b-dropdown
            singleton-group="manager"
            placement="right-start"
            appendTo="body"
            style="overflow: visible; min-width: 240px">
            <div class="dropdown-item" @click="createList">
              <div class="d-flex nope-justify-content-center" style="width: 30px">
                <Icon name="tabler:square-rounded-plus" size="17" width="1.5" class="text-muted" />
              </div>

              <span>Create a new list</span>
            </div>
            <div class="dropdown-divider">
              <v-progress-linear
                v-if="lmeta.working"
                color="deep-purple accent-4"
                indeterminate
                height="3"
                style="margin-top: -3px; position: absolute; top: unset; left: 0" />
            </div>
            <div
              style="
                padding: 3px;
                overflow-y: auto;
                max-height: 250px;
                overscroll-behavior: contain;
              ">
              <div
                v-for="(list, i) in lists"
                :key="'list-' + i"
                class="dropdown-item control-hover"
                :class="{ disabled: lmeta.working }"
                @click="modifyList(list, app)">
                <!-- <div class="d-flex" style="width: 30px">

                <Icon name="tabler:mist" size="17" width="1.5" class="text-muted" />
              </div> -->

                <div
                  class="me-1"
                  style="
                    overflow-wrap: break-word;

                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 210px;
                  ">
                  {{ list.name }}
                </div>

                <template v-if="listHasApp(list, app)">
                  <small class="text-muted ms-auto hide-hover text-end" style="min-width: 40px">
                    <Icon name="tabler:check" size="12" width="1" />
                    Added
                  </small>
                  <small class="text-muted ms-auto show-hover text-end" style="min-width: 40px">
                    Remove
                  </small>
                </template>

                <template v-else>
                  <small
                    class="ms-auto text-secondary hide-hover font-mono text-end"
                    style="min-width: 40px">
                    {{ list.games?.length || 0 }}
                  </small>
                  <small class="text-muted ms-auto show-hover text-end" style="min-width: 40px">
                    Add
                  </small>
                </template>
              </div>
            </div>
          </b-dropdown>
        </div>

        <div class="dropdown-divider"></div>

        <!--
          *+---------------------------------
          *| Add to library
          *| Click to add a game to library
          *+--------------------------------- -->
        <div v-if="!app.is || !app.is.lib" class="dropdown-item" @click="addToLibrary">
          <div class="d-flex nope-justify-content-center" style="width: 30px">
            <Icon name="tabler:square-rounded-plus" size="17" width="1.5" class="text-muted" />
          </div>

          <span>Add to your library</span>
          <!-- <tippy
            :allow-h-t-m-l="true"
            class="text-muted ms-auto cursor-help"
            content="Adding a game to your library will include it in your games list">
            <span class="form-help">?</span>
          </tippy> -->
        </div>

        <!--
          *+---------------------------------
          *| Favorite
          *| Simple item with fav option
          *+--------------------------------- -->
        <div class="dropdown-item" @click="setState({ id: 'fav' })">
          <template v-if="app.is && app.is.fav">
            <div class="d-flex nope-justify-content-center" style="width: 30px">
              <Icon
                name="tabler:heart"
                size="17"
                width="1.5"
                style="color: red; fill: #ff000094; filter: drop-shadow(1px 1px 6px #00000069)" />
            </div>
            <span>No longer favorite</span>
          </template>

          <template v-else>
            <div class="d-flex nope-justify-content-center" style="width: 30px">
              <Icon name="tabler:heart" size="17" width="1.5" class="text-muted" />
              <!-- <Icon name="tabler:bookmark-plus" size="17" width="1.5" class="text-muted" /> -->
            </div>

            <span>Add to favorites</span>
            <tippy
              :allow-h-t-m-l="true"
              class="text-muted ms-auto cursor-help"
              content="Add this game to your favorites list. Marking as favorite will also add the game to your library">
              <span class="form-help">?</span>
            </tippy>
          </template>
        </div>

        <!--
          *+---------------------------------
          *| Pinned
          *| Simple item with pin option
          *+--------------------------------- -->
        <div class="dropdown-item" @click="setState({ id: 'pinned' })">
          <template v-if="app.is && app.is.pinned">
            <div class="d-flex nope-justify-content-center" style="width: 30px">
              <Icon
                name="tabler:bookmark-filled"
                size="17"
                width="1.5"
                style="
                  fill: #1f4112d9 !important;
                  filter: drop-shadow(rgba(0, 0, 0, 0.41) 1px 1px 6px);
                  stroke: #0b651c;
                " />
            </div>
            <span>Unpin</span>
          </template>

          <template v-else>
            <div class="d-flex nope-justify-content-center" style="width: 30px">
              <Icon name="tabler:bookmark-plus" size="17" width="1.5" class="text-muted" />
            </div>

            <span>Pin this</span>
          </template>

          <tippy
            :allow-h-t-m-l="true"
            class="text-muted ms-auto cursor-help"
            content="Add this game to a special list for quick access ~ This does not add the game to your library">
            <span class="form-help">?</span>
          </tippy>
        </div>

        <!--
          *+---------------------------------
          *| Hide
          *| Click to hide a game
          *+--------------------------------- -->
        <div class="dropdown-divider"></div>

        <div class="dropdown-item" @click="setState({ id: 'hidden' })">
          <template v-if="app.is && app.is.hidden">
            <div class="d-flex nope-justify-content-center" style="width: 30px">
              <Icon name="tabler:restore" size="17" width="1.5" />
            </div>
            <span class="me-3">Restore visibility</span>
          </template>

          <template v-else>
            <div class="d-flex nope-justify-content-center" style="width: 30px">
              <Icon name="tabler:cancel" size="17" width="1.5" class="text-muted" />
            </div>

            <span>Hide this game</span>
          </template>

          <tippy
            :allow-h-t-m-l="true"
            class="text-muted ms-auto cursor-help"
            content="Hidden games will not be displayed in any list or search result ~ Those games are still part of your library, just hidden">
            <span class="form-help">?</span>
          </tippy>
        </div>

        <!--
          *+---------------------------------
          *| Delete this
          *| Simple item
          *+--------------------------------- -->
        <template v-if="app.is && app.is.lib">
          <div class="dropdown-item" @click="deleteme">
            <div class="d-flex nope-justify-content-center" style="width: 30px">
              <Icon name="tabler:playlist-x" size="17" width="1.5" class="text-muted" />
            </div>

            <span>Remove from library</span>

            <tippy
              :allow-h-t-m-l="true"
              class="text-muted ms-auto cursor-help"
              content="Delete this game from your library.<br>You might want to do this to fix duplicates or errors">
              <span class="form-help">?</span>
            </tippy>
          </div>
        </template>

        <div v-if="!ui.isRightClick" class="dropdown-item">
          <div class="d-flex nope-justify-content-center" style="width: 30px">
            <Icon name="tabler:mouse" size="17" class="text-muted" />
          </div>

          <div>
            <span href="javascript:void(0)" class="dropdown-header p-0">You can just click</span>
            <small class="d-block text-secondary">
              Open this menu with right click on the game
            </small>
          </div>
        </div>
      </div>
    </template>
  </tippy>

  <!-- <div
    v-if="ui.show"
    class="card nope-card-stacked"
    style="position: fixed; z-index: 9999"
    :style="{ top: ui.top, left: ui.left }">
    <div
      class="dropdown-menu"
      style="
        display: inline-block;
        width: 100%;
        position: relative;
        top: 0;
        box-shadow: none;
      ">
      <div class="row m-0 mb-2">
        <div class="text-center p-2 col-6 active">Status</div>
        <div class="text-center p-2 col-6 active">Collections</div>
      </div>
      <div class="dropdown-item">
        {{ appUUID }}
      </div>
      <label
        v-for="(state, i) in states"
        :key="'state' + i"
        class="dropdown-item"
        @click="setState(state)">
        <div class="d-flex justify-center" style="width: 30px">
          <Icon name="tabler:home" v-if="isFav(state.name)" style="color: red; fill: pink">Heart</Icon>
          <span
            v-else
            class="badge"
            :style="{ 'background-color': state.color || '' }"></span>
        </div>

        <span class="pe-3">
          {{ state.name }}
        </span>
        <tippy class="text-muted ms-auto cursor-help" :content="state.description">
          <Icon name="tabler:help-circle-filled" />
        </tippy>
        <span class="badge bg-primary text-primary-fg ms-auto">12</span>
      </label>
    </div>
  </div> -->
  <div
    v-if="ui.backdrop"
    class="dropdown-control"
    style="
      background-color: rgba(0, 0, 0, 0.7);
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0px;
      left: 0px;
      z-index: 9998;
      backdrop-filter: blur(0.5px);
    "
    click="hide"></div>

  <!-- prettier-ignore-start -->
  <!-- prettier-ignore-end -->

  <component :is="'style'" id="dynamic-state-vars" type="text/css">
    <template v-for="(state, i) in states" :key="'state' + i">
      --bckg-state-{{ state.id }}: {{ state.color }};
    </template>
  </component>
  <component :is="'style'" id="dynamic-states" type="text/css">
    <template v-for="(state, i) in states" :key="'state' + i">
      .bckg-state-{{ state.id }}{ color: {{ state.color }}; }
    </template>
  </component>
</template>

<script>
/**
 * @file:    \components\b\stateMenu.vue
 * @desc:    ...
 * -------------------------------------------
 * Created Date: 29th November 2023
 * Modified: 5th March 2026 - 11:03:39
 **/

export default {
  name: 'GameRightMenu',
  props: {},

  data() {
    return {
      appUUID: null,
      app: {},

      ui: {
        backdrop: false,
        isRightClick: false,
      },
    }
  },

  computed: {
    ...mapStores(useDataStore, useStateStore, useGameStore, useListStore),
    ...mapState(useStateStore, ['states']),
    ...mapState(useListStore, {
      lists: 'lists',
      lmeta: 'meta',
    }),

    currState() {
      return this.states.find((state) => state.id == this.app.state)
    },
  },

  methods: {
    //+-------------------------------------------------
    // function()
    // Displays the component on event position
    // -----
    // Created on Thu Jan 04 2024
    // Updated on Tue Feb 06 2024 - move logic to tippy
    //+-------------------------------------------------
    show(event, app) {
      this.$refs.tippy.setProps({
        appendTo: () => document.body,

        getReferenceClientRect: () => ({
          width: 0,
          height: 0,
          top: event.clientY,
          bottom: event.clientY,
          left: event.clientX,
          right: event.clientX,
        }),

        // popperOptions: {
        //   strategy: 'fixed',
        // },
      })

      this.appUUID = app
      this.app = this.dataStore.get(app)
      this.ui.backdrop = true
      this.ui.isRightClick = event.button !== 0 || event.type == 'contextmenu'

      this.$refs.tippy.show()
    },

    hide() {
      this.ui.backdrop = false
      this.$refs.tippy.hide()
    },

    hideBackdrop() {
      this.ui.backdrop = false
    },

    //+-------------------------------------------------
    // addToLibrary()
    // Adds a game to the user library
    // -----
    // Created on Tue Jul 23 2024
    // Updated on Fri Feb 28 2025 - throught $data
    //+-------------------------------------------------
    addToLibrary() {
      this.dataStore.addToLibrary(this.app.uuid)

      this.$toast.success(this.app.name + ' has been added to your library')
      this.$mitt.emit('library:added')

      this.hide()
    },

    //+-------------------------------------------------
    // setState()
    // Change state on item
    // -----
    // Created on Sat Jan 06 2024
    // Updated on Sat Mar 01 2025 - throught $state
    //+-------------------------------------------------
    setState(state) {
      this.value = state?.id || null
      this.stateStore.set(this.app.uuid, state.id)

      this.hide()
    },

    //+-------------------------------------------------
    // modifyList()
    // Modifies a list and adds or removes an item from it
    // -----
    // Created on Thu Oct 24 2024
    //+-------------------------------------------------
    async modifyList(list, app) {
      await this.listStore.modify(list.uuid, app)
      this.$nuxt.$toast.success(`${app.name} has been added to ${list.name}`)

      this.hide()
    },

    //+-------------------------------------------------
    // listHasApp()
    // Looks if a list has an app
    // -----
    // Created on Fri Oct 25 2024
    //+-------------------------------------------------
    listHasApp(list, app) {
      return this.listStore.hasApp(list, app)
    },

    //+-------------------------------------------------
    // createList()
    // Creates a new list
    // -----
    // Created on Thu Sep 19 2024
    //+-------------------------------------------------
    createList() {
      // const app = { ...this.app }
      this.$mitt.emit('list:create')

      this.hide()
    },

    deleteme() {
      this.dataStore.delete(this.appUUID)
      this.hide()
    },

    init() {},
  },

  mounted() {
    this.init()

    this.$mitt.on('game:manager', (payload) => {
      this.show(payload.$ev, payload.app)
    })
  },
}
</script>
